module.exports = __webpack_public_path__ + "static/img/logo2.4f91689.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/exportPdfworks/logo2.svg
// module id = Z6+S
// module chunks = 4